import { render, staticRenderFns } from "./DadosInfoGeral.vue?vue&type=template&id=156349f4"
import script from "./DadosInfoGeral.vue?vue&type=script&lang=js"
export * from "./DadosInfoGeral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports